import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box, Button, rem, Text } from '@bonusly/design-system';

import { Budget } from '../../lib/entities/budget';
import { useBalanceData } from './hooks/use-balance-data';

interface AmountBalanceProps {
	allowanceBoostId?: string;
	budget: Budget;
}

export const AmountBalance: FC<AmountBalanceProps> = ({ allowanceBoostId = '', budget }) => {
	const { t } = useTranslation('components');
	const { description } = useBalanceData();

	if (!budget.data.balance) {
		if (budget.data.delegateName) {
			return null;
		}

		return (
			<Box textAlign="center" maxW={rem(240)} px={2}>
				<Text color="text.default" fontSize="md" fontWeight="medium" mb={2}>
					{t('rich_media.amount.no_balance_title', {
						currency: budget.data.display.plural,
					})}
				</Text>

				<Text color="text.soft" fontSize="sm" fontWeight="normal" mb={4}>
					{description}
				</Text>

				<Button as={Link} to={`/rewards/${allowanceBoostId}`} w="full">
					{t('rich_media.amount.add_to_balance_button')}
				</Button>
			</Box>
		);
	}

	const balanceLabel = budget.data.delegateName
		? t('rich_media.amount.delegate_balance_available', {
				amount: budget.formattedBalance(),
				name: budget.data.delegateName,
			})
		: t('rich_media.amount.balance_available_to_give', {
				amount: budget.formattedBalance(),
			});

	return (
		<Box px={2} py={2}>
			<Text fontSize="sm" fontWeight="medium" lineHeight={5} color="text.softer">
				{balanceLabel}
			</Text>
		</Box>
	);
};
